const MODULE_NAME = 'PATIENT_STUDIES';
const PATIENT_STUDIES_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const PATIENT_STUDIES_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const PATIENT_STUDY_FETCH_STARTED = MODULE_NAME + 'STUDY_FETCH_STARTED';
const PATIENT_STUDY_FETCH_COMPLETED = MODULE_NAME + 'STUDY_FETCH_COMPLETED';
const PATIENT_STUDY_ASSIGN_SUBMIT_STARTED = MODULE_NAME + 'ASSIGN_STARTED';
const PATIENT_STUDY_ASSIGN_SUBMIT_COMPLETED = MODULE_NAME + 'ASSIGN_COMPLETED';

export {
  PATIENT_STUDIES_FETCH_COMPLETED,
  PATIENT_STUDIES_FETCH_STARTED,
  PATIENT_STUDY_FETCH_STARTED,
  PATIENT_STUDY_FETCH_COMPLETED,
  PATIENT_STUDY_ASSIGN_SUBMIT_STARTED,
  PATIENT_STUDY_ASSIGN_SUBMIT_COMPLETED
};
